__turbopack_context__.v({
  "articleContainer": "ueHDrG_articleContainer",
  "backButton": "ueHDrG_backButton",
  "container": "ueHDrG_container",
  "isHidden": "ueHDrG_isHidden",
  "isShowOnMobile": "ueHDrG_isShowOnMobile",
  "isVisible": "ueHDrG_isVisible",
  "menuSecond": "ueHDrG_menuSecond",
  "menuSecondContainer": "ueHDrG_menuSecondContainer",
  "menuThird": "ueHDrG_menuThird",
  "menuThirdContainer": "ueHDrG_menuThirdContainer",
  "mobileMenuThirdContainer": "ueHDrG_mobileMenuThirdContainer",
  "mobileMenuThirdList": "ueHDrG_mobileMenuThirdList",
  "navigationContacts": "ueHDrG_navigationContacts",
  "showAll": "ueHDrG_showAll",
});
